import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin, Twitter, Mail, MapPin, Phone } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#0a193a] text-white/80 pt-20 pb-10 border-t border-white/10" data-id="element-61" data-mp="3ggka709t7m26">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-62" data-mp="32pfci3q053uh">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-12 lg:gap-8 mb-16" data-id="element-63" data-mp="36oo9rik93jus">
          {/* Brand Col */}
          <div className="lg:col-span-4" data-id="element-64" data-mp="3ufjvpz20zku4">
            <img src="https://cdn.magicpatterns.com/uploads/9pNo3tTwvFYBri2vFZFThu/Arissa_Cost_Solutions_Logo.png" alt="Arissa Cost Solutions" className="h-12 w-auto mb-6 object-contain" data-id="element-65" data-mp="38quiv78flpl" />
            <p className="text-sm leading-relaxed mb-6 max-w-sm" data-id="element-66" data-mp="3qcdpgrewxtnn">
              Helping employers navigate care for their injured workers. We
              provide highly integrated and comprehensive managed care services
              for Workers' Compensation and liability claims.
            </p>
            <div className="flex space-x-4" data-id="element-67" data-mp="3laljxq66apz8">
              <a href="#" className="text-white/60 hover:text-brand-gold transition-colors" data-id="element-68" data-mp="3lbdbmpwng3k8">
                <Linkedin className="w-5 h-5" data-id="element-69" data-mp="3v7zuj95f0kjm" />
              </a>
              <a href="#" className="text-white/60 hover:text-brand-gold transition-colors" data-id="element-70" data-mp="3q8n125k1gf82">
                <Twitter className="w-5 h-5" data-id="element-71" data-mp="81yxwl8ju251" />
              </a>
            </div>
          </div>

          {/* Services Col */}
          <div className="lg:col-span-3 lg:col-start-6" data-id="element-72" data-mp="33nmw76ipll8">
            <h4 className="text-white font-serif font-bold text-lg mb-6" data-id="element-73" data-mp="ht3bphmhngya">
              Services
            </h4>
            <ul className="space-y-3 text-sm" data-id="element-74" data-mp="cus3tcfr7gip">
              <li data-id="element-75" data-mp="cw36ta1dkk8r">
                <Link to="/services/ancillary" className="hover:text-brand-gold transition-colors" data-id="element-76" data-mp="qt8flhsh3x7p">
                  A+ Ancillary Services
                </Link>
              </li>
              <li data-id="element-77" data-mp="twfnps3h9trd">
                <Link to="/services/bill-review" className="hover:text-brand-gold transition-colors" data-id="element-78" data-mp="twxsjd47hgaw">
                  Medical Bill Review
                </Link>
              </li>
              <li data-id="element-79" data-mp="18jqznv3knfs0">
                <Link to="/services/case-management" className="hover:text-brand-gold transition-colors" data-id="element-80" data-mp="18k959ic4j6cl">
                  Case Management
                </Link>
              </li>
              <li data-id="element-81" data-mp="1hj4buvj2yigf">
                <Link to="/services/utilization-review" className="hover:text-brand-gold transition-colors" data-id="element-82" data-mp="1hms4ztkm52um">
                  Utilization Review
                </Link>
              </li>
              <li data-id="element-83" data-mp="3oboppmyxfvkq">
                <Link to="/services/triage" className="hover:text-brand-gold transition-colors" data-id="element-84" data-mp="3oc6p2sgvypwv">
                  Medical Triage
                </Link>
              </li>
              <li className="pt-3 mt-3 border-t border-white/10" data-id="element-85" data-mp="2agewjq0gybaq">
                <Link to="/about" className="hover:text-brand-gold transition-colors font-semibold" data-id="element-86" data-mp="25ncae2y0u44k">
                  About Us
                </Link>
              </li>
              <li data-id="element-87" data-mp="1wpa53b798pbh">
                <Link to="/contact" className="hover:text-brand-gold transition-colors font-semibold" data-id="element-88" data-mp="1wlmae8q2pwv6">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Col */}
          <div className="lg:col-span-4" data-id="element-89" data-mp="2kbgkiij0d7bq">
            <h4 className="text-white font-serif font-bold text-lg mb-6" data-id="element-90" data-mp="2fegnex44zewr">
              Contact Us
            </h4>
            <ul className="space-y-4 text-sm" data-id="element-91" data-mp="18yef8jmd046v">
              <li className="flex items-start" data-id="element-92" data-mp="18w1n5dmw0dg3">
                <Phone className="w-5 h-5 mr-3 text-brand-gold flex-shrink-0" data-id="element-93" data-mp="13ys1m92mclxj" />
                <div data-id="element-94" data-mp="2rvzm7cez23t6">
                  <div data-id="element-95" data-mp="2rvhdvhf1bz4w">
                    <a href="tel:8552601053" className="hover:text-white transition-colors" data-id="element-96" data-mp="2ru6edtsmhdjl">
                      855.260.1053
                    </a>{' '}
                    (Toll Free)
                  </div>
                  <div className="mt-1" data-id="element-97" data-mp="2nv7beeqgbqus">
                    <a href="tel:7142591053" className="hover:text-white transition-colors" data-id="element-98" data-mp="2ns1nh2tk6v0n">
                      714.259.1053
                    </a>{' '}
                    (Local)
                  </div>
                </div>
              </li>
              <li className="flex items-center" data-id="element-99" data-mp="31nwvueqc0nps">
                <Mail className="w-5 h-5 mr-3 text-brand-gold flex-shrink-0" data-id="element-100" data-mp="36jkkmt0wjeur" />
                <a href="mailto:info@arissacs.com" className="hover:text-white transition-colors" data-id="element-101" data-mp="1q5uezhu4wij0">
                  info@arissacs.com
                </a>
              </li>
              <li className="flex items-start" data-id="element-102" data-mp="1nkmpgbqvon6h">
                <MapPin className="w-5 h-5 mr-3 text-brand-gold flex-shrink-0 mt-0.5" data-id="element-103" data-mp="1imuypl1yz73v" />
                <span data-id="element-104" data-mp="1ip7djpcfl1cp">
                  Corporate Headquarters
                  <br data-id="element-105" data-mp="1wm43lokq6esj" />
                  2415 Campus Dr., Suite 250
                  <br data-id="element-106" data-mp="1rnb10r6z8875" />
                  Irvine, CA 92612
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center text-xs text-white/50" data-id="element-107" data-mp="zwdants30zou">
          <p data-id="element-108" data-mp="1do1ivlz7n40j">
            &copy; {new Date().getFullYear()} Arissa Cost Solutions. All rights
            reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-109" data-mp="18vi4imsp84uo">
            <Link to="/privacy" className="hover:text-white transition-colors" data-id="element-110" data-mp="l6yx09hh3w3n">
              Privacy Policy
            </Link>
            <Link to="/privacy" className="hover:text-white transition-colors" data-id="element-111" data-mp="g7meu21jrd7e">
              Terms of Service
            </Link>
            <Link to="/privacy" className="hover:text-white transition-colors" data-id="element-112" data-mp="2g8j6dpqguy2m">
              Compliance
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}